import { OwcInput, OwcSlideToggle } from "@one/react";
import { FormikProps } from "formik";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";
import { ACTION_LOG_ACTION_TYPE } from "../../../../constants";
import { useFieldPropagationToggle } from "../../../../utils/hooks/useFieldPropagationToggle";
import { useEffect } from "react";

const configurationBaselineActionTypes = [
  ACTION_LOG_ACTION_TYPE.HARDWARE_CHANGE,
  ACTION_LOG_ACTION_TYPE.CONFIGURATION_CHANGE,
  ACTION_LOG_ACTION_TYPE.REPAIR,
  ACTION_LOG_ACTION_TYPE.TROUBLESHOOTING,
  ACTION_LOG_ACTION_TYPE.QUALITY_SUPPORT_NOTIFICATION
];

export const ConfigurationBaselineInputWithSwitch = ({
  formik,
  isPropagationDisabled,
  numberOfSelectedEquipment,
  editMode,
  defaultValue = ''
}: {
  formik: FormikProps<{
    logbookConfigurationBaseline: {
      newValue: string;
      shouldBePublished: boolean;
    };
    action: string;
  }>;
  isPropagationDisabled?: boolean;
  editMode: boolean;
  numberOfSelectedEquipment: number;
  defaultValue: string;
}) => {
  const isBulk = numberOfSelectedEquipment > 1;
  const bulkDefaultValue = numberOfSelectedEquipment > 1 || defaultValue === null ? '' : defaultValue;
  const isCorrespondingActionType = configurationBaselineActionTypes.includes(formik.values.action);

  const { isToggleDisabled } = useFieldPropagationToggle({
    formikValue: formik.values.logbookConfigurationBaseline,
    defaultValue: bulkDefaultValue,
    label: "logbookConfigurationBaseline",
    setFieldValue: formik.setFieldValue,
    disabled: !isCorrespondingActionType || editMode || isPropagationDisabled
  });

  useEffect(() => {
    if (isCorrespondingActionType) {
      formik.setFieldValue("logbookConfigurationBaseline.newValue", bulkDefaultValue);
    }

    if (!isCorrespondingActionType && formik.values.logbookConfigurationBaseline?.newValue) {
      formik.setFieldValue("logbookConfigurationBaseline.newValue", "");
      formik.setFieldValue("logbookConfigurationBaseline.shouldBePublished", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCorrespondingActionType, numberOfSelectedEquipment]);

  return isCorrespondingActionType ? (
    <div style={{ gridColumn: "span 2" }}>
      <OwcInput
        {...react18WorkaroundProps}
        onBlur={formik.handleBlur}
        data-testid="action-data-inputs-new-config-baseline-input"
        variant="filled"
        id="logbookConfigurationBaseline.newValue"
        name="logbookConfigurationBaseline.newValue"
        label={"Configuration baseline"}
        value={formik.values.logbookConfigurationBaseline.newValue}
        onInputChange={formik.handleChange}
        onInputKeyDown={formik.handleChange}
        style={{
          width: "100%"
        }}
      >
        {isBulk ? <span slot="assistive-text">Empty means “Keep current values”, Filled means “Set all to new value”</span> : null}
      </OwcInput>
      <OwcSlideToggle
        {...react18WorkaroundProps}
        checked={formik.values.logbookConfigurationBaseline.shouldBePublished}
        onInputChange={(event: { detail: any }) =>
          formik.setFieldValue("logbookConfigurationBaseline.shouldBePublished", event.detail)
        }
        id="logbookConfigurationBaseline.shouldBePublished"
        disabled={editMode || isPropagationDisabled || isToggleDisabled}
      >
        Publish ”Configuration baseline” to Equipment Repository
      </OwcSlideToggle>
    </div>
  ) : (
    <></>
  );
};
